import mock from '../mock'

// ** Third Party Components
import axios from 'axios'

// ** Utils
import { paginateArray } from '../utils'

// ** Utils
import { getUserData } from '@utils'

// ** Custom Components
import GetApiCOC from '../../@fake-db/ApiCOC'

const base64ToString = (response) => { 

  if (response.data.Result === "true" && response.data.response_data.length > 0) {
    return JSON.parse(Buffer.from(response.data.response_data, "base64").toString()) 
  } else {
    return []
  }
}

const getAssistanceOffice = async (dataOrigen, refrescar, api, token, body, config) => {

  const configws = {
    method: 'get',
    url:    api,
    headers: { 
      Accept:      'application/json',
      obrientoken: token
    },
    params: body
  }

  let data = dataOrigen

  if (data.assistance_list.length <= 0 || data.date_from !== config.startDate || data.date_to !== config.endDate) {
    const response = await axios(configws)
    data = { assistance_list: base64ToString(response) }
  }

  // eslint-disable-next-line object-curly-newline
  const { q = '', perPage = 10, page = 1, sort, sortColumn } = config

  /* eslint-enable */
  const dataAsc = data.assistance_list.sort((a, b) => {
    const valueA = a[sortColumn]
    const valueB = b[sortColumn]

    if (valueA === null && valueB === null) {
      return 0 // Si ambos son nulos, consideramos que son iguales
    }

    if (valueA === null) {
      return 1 // Si el valor de A es nulo, lo colocamos después de B
    }

    if (valueB === null) {
      return -1 // Si el valor de B es nulo, lo colocamos antes de A
    }

    // Si ninguno de los valores es nulo, realizamos la comparación normal
    if (valueA < valueB) {
      return -1
    } else if (valueA > valueB) {
      return 1
    } else {
      return 0
    }
  })

  const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

  const queryLowered = q.toLowerCase()
  const filteredData = dataToFilter.filter(asistance_list => {

      const statusDes = asistance_list.status === 0 ? 'fuera' : 'adentro'

      const convertirYFormatearFecha = (fecha) => {

        return new Date(fecha).toLocaleString('en-GB', { 
          year: 'numeric', 
          month: '2-digit', 
          day: '2-digit', 
          hour: '2-digit', 
          minute: '2-digit', 
          second: '2-digit' 
        })
      }

      return (
        (
          (asistance_list.username     && String(asistance_list.username).toLowerCase().includes(queryLowered)) ||
          (asistance_list.in_hour      && convertirYFormatearFecha(asistance_list.in_hour).toLowerCase().includes(queryLowered)) ||
          (asistance_list.out_hour     && convertirYFormatearFecha(asistance_list.out_hour).toLowerCase().includes(queryLowered)) ||
          (asistance_list.last_in_hour && convertirYFormatearFecha(asistance_list.last_in_hour).toLowerCase().includes(queryLowered)) ||
          (asistance_list.total_hour   && String(asistance_list.total_hour).toLowerCase().includes(queryLowered)) ||
          (asistance_list.comment_out  && String(asistance_list.comment_out).toLowerCase().includes(queryLowered)) ||
          statusDes.includes(queryLowered)
        )
      )
  })

  return [
    200,
    {
      allData: data.assistance_list,
      total: filteredData.length,
      assistance_list: filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page)
    }
  ]  
}

// ------------------------------------------------
// GET: Return closure List for Comission
// ------------------------------------------------
let dataOffice = JSON.parse(localStorage.getItem("dataOffice")) || { assistance_list: [], startDate: '', endDate: '', cluster: -1, country: -1, office: -1, user: -1}

mock.onGet('/apps/offices/list').reply(async config => {

  const user = getUserData()
  
  let cluster_id = ''
  let office_id  = ''
  let country_id = ''
  let username    = ''

  if (config.manager) {
    if (config.cluster_id !== -1 && config.cluster_id !== '') {
      cluster_id = config.cluster_id
    }

    if (config.country_id !== -1 && config.country_id !== '') {
      country_id = config.country_id
    }

    if (config.office_id !== -1 && config.office_id !== '') {
      office_id = config.office_id
    }
      
    if (config.username !== -1 && config.username !== '') {
      username  = config.username
    }
  } else {
    cluster_id = user.usercoc.cluster
    office_id  = user.usercoc.office_id
    country_id = user.usercoc.country
    username    = user.usercoc.username
  }

  if (config.report) {
    config.reset = true
    if (config.user_id !== '') {
      username = config.user_id
    }
  }  
  
  const body = {
    cluster   : cluster_id,
    country   : country_id,
    office    : office_id,
    user_id   : username,
    date_from : config.startDate,
    date_to   : config.endDate
  }

  if (localStorage.getItem("resetAssistanceOffice")) {
    if (localStorage.getItem("resetAssistanceOffice") === "true") {
      config.reset = true
    }

    localStorage.removeItem("resetAssistanceOffice")
  }

  const now = new Date()
  const diffInMinutes = (now - dataOffice.last) / (1000 * 60)

  if (diffInMinutes >= 5) {
    config.reset = true
  }

  if (config.reset) {
    dataOffice = { assistance_list: [], date_from: '', date_to: '', cluster: -1, country: -1, office: -1, user: -1 }
  }

  const result = await getAssistanceOffice(dataOffice, 1, GetApiCOC('getListAssistanceOffice'), user.token, body, config)

  dataOffice = { assistance_list: result[1].allData, date_from: config.startDate, date_to: config.endDate, cluster: cluster_id, country: country_id, office: office_id, user_id: username }

  localStorage.setItem("dataOffice", JSON.stringify(dataOffice))

  return result
})
